import { useState } from 'react';
import { Download, ExternalLink, Loader2 } from 'lucide-react';

const ASSETS = [
  { name: 'Village Star-Revue (VSR) Square Logo', spec: 'JPG · square · for print & web', btn: 'Download VSR Logo', url: 'https://files-public.monday.com/use1/f0a21486-12ac-4679-bdbf-36da7896167c/VSR%20Square%20Logo.jpg', file: 'VSR_Square_Logo.jpg' },
  { name: 'Red Hook Star-Revue (RHS / RHSR) Square Logo', spec: 'PNG · square · dark blue', btn: 'Download RHS Logo', url: 'https://files-public.monday.com/use1/32ae5d02-6921-4432-ad43-fd341f521312/DARK%20BLUE%20Red%20Hook%20Star-Revue%20logo%20square.png', file: 'RHSR_Square_Logo.png' },
  { name: 'The Scene — Calendar Banner & Flag Graphic', spec: 'PNG · wide banner · header artwork', btn: 'Download Scene Flag', url: 'https://gbrook8344s-team-company.monday.com/generated_static/35711259/e7525548-33cf-43c6-8e4f-3b660fd06bfa.png', file: 'The_Scene_Calendar_Flag.png' },
];

export function AssetsPage() {
  const [busy, setBusy] = useState<string | null>(null);
  const download = async (url: string, file: string) => {
    setBusy(file);
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(String(res.status));
      const href = URL.createObjectURL(await res.blob());
      const a = document.createElement('a');
      a.href = href; a.download = file; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(href), 1000);
    } catch (e) {
      console.error(e);
      window.open(url, '_blank', 'noopener');
    } finally { setBusy(null); }
  };
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 [--font-heading:'Outfit',system-ui,sans-serif]">
      <header className="border-b-4 border-double border-foreground pb-3">
        <h2 className="font-[family-name:var(--font-heading)] text-3xl font-semibold sm:text-4xl">Assets</h2>
        <p className="mt-1 max-w-3xl text-sm text-muted-foreground">Official logos, mastheads, and calendar graphics for <span className="italic">The Village Star-Revue</span> and <span className="italic">Red Hook Star-Revue</span>. Click download to save high-resolution files for InDesign layout or digital publication.</p>
      </header>
      <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ASSETS.map((a) => (
          <article key={a.file} className="flex min-w-0 flex-col border border-foreground bg-card">
            <div className="flex aspect-square items-center justify-center border-b border-border bg-background p-5">
              <img src={a.url} alt={a.name} className="max-h-full max-w-full object-contain" />
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="text-base font-semibold">{a.name}</h3>
              <p className="mt-1 text-xs text-muted-foreground">{a.spec}</p>
              <p className="mt-0.5 break-all font-mono text-xs text-muted-foreground">{a.file}</p>
              <div className="mt-auto flex flex-wrap gap-2 pt-4">
                <button type="button" onClick={() => void download(a.url, a.file)} disabled={busy !== null} className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 bg-primary px-4 text-sm font-semibold text-primary-foreground disabled:opacity-50">
                  {busy === a.file ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}{a.btn}
                </button>
                <a href={a.url} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center gap-2 border border-foreground px-4 text-sm font-semibold"><ExternalLink className="h-4 w-4" />Open Full Res</a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
